<!-- Bouton Retour au parcours appelant ou à l'accueil -->
<app-bouton-retour-accueil *ngIf="!estProvenanceExterne" />
<app-bouton-retour-parcours-externe *ngIf="estProvenanceExterne" />
